// src/components/LoginScreen.jsx
import { useState } from "react";
import { USERS, USER_COLORS } from "../constants";

const S = {
  wrap: {
    fontFamily: "'DM Sans', sans-serif",
    maxWidth: 430,
    margin: "0 auto",
    minHeight: "100vh",
    background: "#F7F4EE",
  },
  topbar: {
    background: "#27500A",
    padding: "24px 20px 20px",
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  logo: {
    height: 52, width: 52, borderRadius: 8,
    objectFit: "contain", background: "#fff", padding: 3, flexShrink: 0,
  },
  title: { color: "#C0DD97", fontSize: 22, fontWeight: 700, letterSpacing: 0.5 },
  sub:   { color: "#7CB85A", fontSize: 12, marginTop: 6 },
  body:  { padding: "24px 16px" },
  hint:  { fontSize: 14, color: "#888", marginBottom: 16 },
  userCard: {
    display: "flex", alignItems: "center", gap: 12,
    cursor: "pointer", padding: "10px 14px",
    borderRadius: 12, border: "1px solid #E8E4DC",
    background: "#fff", marginBottom: 8,
  },
  avatar: (color) => ({
    width: 42, height: 42, borderRadius: "50%",
    background: color + "22",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 15, fontWeight: 700, color, flexShrink: 0,
  }),
  name:  { fontSize: 14, fontWeight: 600, color: "#1a1a1a" },
  role:  { fontSize: 12, color: "#888", marginTop: 1 },
  pinDisplay: {
    background: "#F7F4EE", borderRadius: 10, padding: "14px 16px",
    fontSize: 28, letterSpacing: 10, textAlign: "center",
    color: "#27500A", marginBottom: 12, minHeight: 60,
    border: "1px solid #E0DDD5",
  },
  pinGrid: {
    display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10, marginTop: 12,
  },
  pinKey: {
    background: "#F7F4EE", border: "1px solid #E0DDD5", borderRadius: 10,
    padding: "16px", fontSize: 18, fontWeight: 500, cursor: "pointer",
    textAlign: "center", userSelect: "none",
  },
  backBtn: {
    background: "transparent", border: "none",
    color: "#7CB85A", fontSize: 11, cursor: "pointer",
    marginTop: 4, fontFamily: "'DM Sans', sans-serif",
  },
  err: { color: "#A32D2D", fontSize: 13, textAlign: "center", marginBottom: 8 },
};

// ✅ FIX 3 & 4: logoSrc prop passed in from App.jsx (local file, not imgbb)
// ✅ FIX 4: demoNote block removed entirely — never visible to end users
export default function LoginScreen({ onLogin, logoSrc }) {
  const [selected, setSelected] = useState(null);
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");

  const handleDigit = (d) => {
    if (d === "⌫") { setPin(p => p.slice(0, -1)); setError(""); return; }
    if (pin.length >= 4) return;
    const np = pin + d;
    setPin(np);
    if (np.length === 4) {
      if (np === selected.pin) {
        onLogin(selected);
      } else {
        setError("Wrong PIN. Try again.");
        setTimeout(() => { setPin(""); setError(""); }, 1200);
      }
    }
  };

  // ── User selection screen ─────────────────────────────────────────
  if (!selected) {
    return (
      <div style={S.wrap}>
        <div style={S.topbar}>
          {/* ✅ FIX 2: local logo path via prop */}
          <img src={logoSrc} alt="Leap — Towards Better Health" style={S.logo} />
          <div>
            <div style={S.title}>Dharani Group</div>
            <div style={S.sub}>Wood Pressed Oils — Business Manager</div>
          </div>
        </div>
        <div style={S.body}>
          <div style={S.hint}>Who are you?</div>
          {USERS.map(u => (
            <div key={u.id} style={S.userCard}
              onClick={() => { setSelected(u); setPin(""); setError(""); }}>
              <div style={S.avatar(USER_COLORS[u.id] || USER_COLORS.default)}>
                {u.name[0]}
              </div>
              <div>
                <div style={S.name}>{u.name}</div>
                <div style={S.role}>{u.role}</div>
              </div>
            </div>
          ))}
          {/* ✅ FIX 4: demo PIN note removed — was publicly visible to all users */}
        </div>
      </div>
    );
  }

  // ── PIN entry screen ──────────────────────────────────────────────
  return (
    <div style={S.wrap}>
      {/* ✅ FIX 3: Logo now shown on PIN screen too — consistent across all states */}
      <div style={{ ...S.topbar, justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <img src={logoSrc} alt="Leap — Towards Better Health" style={S.logo} />
          <div>
            <div style={S.title}>{selected.name}</div>
            <div style={S.sub}>{selected.role}</div>
          </div>
        </div>
        <button style={S.backBtn} onClick={() => setSelected(null)}>← Change</button>
      </div>
      <div style={{ padding: "32px 24px" }}>
        <div style={{ fontSize: 14, color: "#888", marginBottom: 12, textAlign: "center" }}>
          Enter your 4-digit PIN
        </div>
        <div style={S.pinDisplay}>
          {"●".repeat(pin.length) || <span style={{ color: "#ccc" }}>_ _ _ _</span>}
        </div>
        {error && <div style={S.err}>{error}</div>}
        <div style={S.pinGrid}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, "", 0, "⌫"].map((d, i) => (
            <div key={i}
              onClick={() => d !== "" && handleDigit(String(d))}
              style={{
                ...S.pinKey,
                opacity: d === "" ? 0 : 1,
                pointerEvents: d === "" ? "none" : "auto",
                background: d === "⌫" ? "#F0EDE6" : S.pinKey.background,
              }}>
              {d}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
